// web/src/lib/supabase.ts — הכניסה (D-245).
// 🔑 Supabase Auth מנפיק את הכרטיס; השרת שלנו מאמת אותו בעצמו (auth.py, ES256) ⛔ והחזית לא ניגשת למסד ישירות.
// ✅ persistSession — הכניסה נשמרת בדפדפן וממתחדשת לבד (autoRefreshToken) ⇒ ⛔ כניסה מחדש כל שעה.
// 🆕 27.09 — @supabase/auth-js בלבד (⛔ supabase-js המלא): החזית משתמשת רק בכניסה, והספרייה המלאה (מסד · אחסון ·
//    זמן אמת) הייתה החלק הגדול בקובץ הראשי. 🔑 storageKey זהה לזה של supabase-js ⇒ מי שכבר מחוברת ⛔ מתנתקת.
import { AuthClient } from "@supabase/auth-js";
import { config } from "./config";

const ref = new URL(config.supabaseUrl).hostname.split(".")[0];

export const supabase = {
  auth: new AuthClient({
    url: `${config.supabaseUrl}/auth/v1`,
    headers: { apikey: config.supabaseKey, Authorization: `Bearer ${config.supabaseKey}` },
    storageKey: `sb-${ref}-auth-token`,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }),
};
